import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "text-subtitle-2 flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "base-skeleton-loader__item",
    style: {"height":"1.5em"}
  })
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-caption base-skeleton-loader__item" }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-body-2 mt-5px base-skeleton-loader__item" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-caption base-skeleton-loader__item" }),
  /*#__PURE__*/_createElementVNode("div", { class: "text-body-2 mt-5px base-skeleton-loader__item" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_evonum_avatar = _resolveComponent("evonum-avatar")!
  const _component_evonum_card_list_item = _resolveComponent("evonum-card-list-item")!

  return (_ctx.variant == 'MULTILINELISTITEM')
    ? (_openBlock(), _createBlock(_component_evonum_card_list_item, { key: 0 }, {
        avatar: _withCtx(() => [
          _createVNode(_component_evonum_avatar, {
            size: 36,
            class: "base-skeleton-loader__item",
            style: {"--evonum-avatar-background-color":"var(--grey-200)","border-radius":"50%"}
          })
        ]),
        headline: _withCtx(() => [
          _hoisted_1
        ]),
        text: _withCtx(() => [
          _hoisted_2,
          _hoisted_3
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}